/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';

const messages = defineMessages({
  error: 'Something went wrong. Reload the page.',
});

const propTypes = {
  error: PropTypes.string,
  children: PropTypes.node.isRequired,
};

const defaultProps = {
  error: undefined,
};

/**
 * Renders if something went wrong in the underlying react build
 */
class ErrorBoundary extends Component {
  static getDerivedStateFromError(error__) {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  render() {
    const { hasError } = this.state;
    const {
      children,
      error,
      intl: { formatMessage },
    } = this.props;
    if (hasError) {
      return <p>{error || formatMessage(messages.error)}</p>;
    }
    return children;
  }
}

ErrorBoundary.propTypes = propTypes;
ErrorBoundary.defaultProps = defaultProps;

export default injectIntl(ErrorBoundary);
